/**
 * Fire-and-forget conversion event tracking.
 *
 * - Never throws errors
 * - Never blocks UI
 * - Works for both anonymous and authenticated users
 * - Sends to POST /api/events/track
 */

type ConversionEvent =
  | 'page_view'
  | 'wallet_connected'
  | 'snap_install_started'
  | 'snap_installed'
  | 'checkout_started'
  | 'checkout_completed'
  | 'upgrade_clicked'
  | 'customer_portal_opened'
  | 'email_captured'
  | 'recovery_started'
  | 'click_subscribe'
  | 'subscription_created'
  | 'snap_upgrade_clicked'
  | 'support_visited'
  | 'pricing_visited'
  | 'transfer_started'
  | 'cta_clicked'
  | 'upgrade_prompt_shown'
  | 'upgrade_prompt_dismissed'
  | 'upgrade_prompt_accepted'
  | 'quota_warning_shown'
  | 'quota_reached_shown'
  | 'revenue_hint_generated'
  | 'revenue_hint_shown'
  | 'revenue_hint_dismissed'
  | 'revenue_hint_clicked'
  | 'intel_teaser_shown'
  | 'intel_teaser_clicked'
  | 'intel_upgrade_cta_shown'
  | 'intel_upgrade_cta_clicked'
  | 'scan_milestone_3'
  | 'scan_milestone_5'
  | 'trial_started'
  | 'trial_converted'
  | 'trial_expired';

export type { ConversionEvent };

export function trackConversion(event: ConversionEvent, metadata?: Record<string, unknown>): void {
  try {
    fetch('/api/events/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventType: event,
        metadata: {
          ...metadata,
          url: window.location.pathname,
          timestamp: Date.now(),
        },
      }),
    }).catch(() => {});
  } catch {
    // Never throw — fire and forget
  }
}
